import { createContext } from 'react';

/**
 * Please use AppContext instead
 * @deprecated This will be removed in Nicollet v8
 */

const NicolletContext = createContext({});
/**
 * Please use AppContext instead
 * @deprecated This will be removed in Nicollet v8
 */

const {
  Provider,
  Consumer
} = NicolletContext;

export { NicolletContext, Consumer as NicolletContextConsumer, Provider as NicolletContextProvider };
